/**
 * Gsap JavaScript singleton module
 */

var Gsap = (function($) {

  ScrollTrigger.defaults({
    toggleActions: "restart pause resume pause",
    scroller: ".container"
  });

  function initActivePanel() {
    
    const panels = gsap.utils.toArray('.panel');
    const captions = document.getElementsByClassName('caption');
    const captionOne = $("#caption-one");
    const captionTwo = $("#caption-two");
    const logoWhite = $('.header-logo__image--white');
    const logoBlack = $('.header-logo__image--black');

    panels.forEach((panel) => {
      gsap.from(panel, {
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom top',
          trigger: panel,

          onEnter() {

            // Add info related to the panel to each caption element
            panel.classList.remove('panel--inactive');
            let captionOneContent = panel.dataset.captionOne;
            let captionTwoContent = panel.dataset.captionTwo;
            captionOne.html(captionOneContent);
            captionTwo.html(captionTwoContent);

            // Check if panel has dark background to change text and logo color
            if(panel.classList.contains('panel--dark')){
              logoBlack.hide();
              logoWhite.show();
              for (const caption of captions) {
                caption.classList.add('panel__caption--white');
              }
            } else {
              logoBlack.show();
              logoWhite.hide();
              for (const caption of captions) {
                caption.classList.remove('panel__caption--white');
              }
            }

            // Check if panel has contact info to change the text alignment of caption two
            if(panel.classList.contains('panel--five')){
              captionTwo.addClass('text--right');
            } else {
              captionTwo.removeClass('text--right');
            }

          },

          onLeave() {
            panel.classList.add('panel--inactive');
            
          },

          onEnterBack() {

            // Add info related to the panel to each caption element
            panel.classList.remove('panel--inactive');
            let captionOneContent = panel.dataset.captionOne;
            let captionTwoContent = panel.dataset.captionTwo;
            captionOne.html(captionOneContent);
            captionTwo.html(captionTwoContent);

            // Check if panel has dark background to change text and logo color
            if(panel.classList.contains('panel--dark')){
              logoBlack.hide();
              logoWhite.show();
              for (const caption of captions) {
                caption.classList.add('panel__caption--white');
              }
            } else {
              logoBlack.show();
              logoWhite.hide();
              for (const caption of captions) {
                caption.classList.remove('panel__caption--white');
              }
            }

             // Check if panel has contact info to change the text alignment of caption two
             if(panel.classList.contains('panel--five')){
              captionTwo.addClass('text--right');
            } else {
              captionTwo.removeClass('text--right');
            }

          },

          onLeaveBack() {
            panel.classList.add('panel--inactive');
          
          }
        }
      });
    });

  }

  function initSplitting() {

    let revealText = document.querySelectorAll(".reveal-text");
    let results = Splitting({ target: revealText, by: "lines" });

    results.forEach((splitResult) => {
        const wrappedLines = splitResult.lines
          .map(
            (wordsArr) => `
            <span class="line"><div class="words">
              ${wordsArr
                .map(
                  (word) => `${word.outerHTML}<span class="whitespace"> 
             </span>`
                )
                .join("")}
            </div></span>`
          )
          .join("");
        splitResult.el.innerHTML = wrappedLines;
    });

    let revealLines = revealText.forEach((element) => {

        let lines = element.querySelectorAll(".line .words");

        let tl = gsap.timeline({
            scrollTrigger: {
            trigger: element,
            toggleActions:"play none none none",
            }
        });
        
        tl.set(revealText, { autoAlpha: 1 });

        tl.from(lines, 0.7, {
            yPercent: 100,
            ease: Power3.out,
            stagger: 0.1,
            delay: 0.50
        });
    });
  }

  function initAnimations() {

      // Client full list columns animation

      let tlColumns = gsap.timeline({
        scrollTrigger: {
          trigger: $('#panel-clients-2'),
          toggleActions:"play none none none",
        }
      });
  
      tlColumns.from($('.column'), 0.85, {
        yPercent: 100,
        ease: Power3.out,
        stagger: 0.1,
        delay: 0.20
    });

    let backgroundPanels = document.querySelectorAll(".panel--background");

    backgroundPanels.forEach((panel) => {
      gsap.from(panel, {
        scrollTrigger: {
          start: 'top bottom',
          end: 'bottom top',
          trigger: panel,

          onEnter() {
            panel.classList.add('panel--zoom');
          },

          onLeave() {
            panel.classList.remove('panel--zoom');
          },

          onEnterBack() {
            panel.classList.add('panel--zoom');
          },

          onLeaveBack() {
            panel.classList.remove('panel--zoom');

          },

        }
      });
    });




    let revealContainers = document.querySelectorAll(".reveal");

    revealContainers.forEach((container) => {

      let image = container.querySelector("img");
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          toggleActions: "restart none none reset"
        }
      });

      tl.set(container, { autoAlpha: 1 });

      tl.from(container, 1.5, {
        xPercent: -100,
        ease: Power2.out
      });

      tl.from(image, 1.5, {
        xPercent: 100,
        scale: 1.1,
        delay: -1.5,
        ease: Power2.out
      });

    });

  }


  function init() {

    initSplitting();
    initActivePanel();
    initAnimations();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Gsap.init);
